export const KeyCodes = {
  Enter: 13,
};
